module.exports = __webpack_public_path__ + "static/media/del.ec8b66d3.png";